module.exports = __webpack_public_path__ + "static/krestonshirley-background-image-6ba6d6b472b1ffea66b03b5f72dd9c30.png";